export default "__VITE_ASSET__ff52e054__"